import { FloatingButtonExtendedThemeStates, FloatingButtonExtendedVariants, } from '../../../../../../components/floatingButtonExtended/types/floatingButtonExtendedTheme';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
export const getPrimaryStyles = (FOUNDATIONS) => ({
    [FloatingButtonExtendedVariants.PRIMARY]: {
        outerContainer: {
            position: 'relative',
            height: FOUNDATIONS.size_450,
            margin_top: FOUNDATIONS.spacing_250,
            margin_bottom: FOUNDATIONS.spacing_250,
        },
        buttonContainer: {
            border_radius: FOUNDATIONS.radius_button_large,
            padding: FOUNDATIONS.spacing_150,
            gap: FOUNDATIONS.spacing_150,
            background_color: FOUNDATIONS.color_comp_actions_floatingbuttonextended_default_bg,
            min_width: FOUNDATIONS.size_450,
            height: FOUNDATIONS.size_450,
            border_width: FOUNDATIONS.border_comp_actions_button_bordersize,
            border_style: 'solid',
            border_color: FOUNDATIONS.color_comp_actions_floatingbutton_border,
            overflow: 'hidden',
            display: 'flex',
            align_items: 'center',
            justify_content: 'center',
            cursor: 'pointer',
            position: 'fixed',
            bottom: FOUNDATIONS.spacing_250,
            right: FOUNDATIONS.spacing_250,
            defaultWith: FOUNDATIONS.size_450,
            extendWidth: `calc(100% - (${FOUNDATIONS.spacing_250} + ${FOUNDATIONS.spacing_250}))`,
            transition: 'width 150ms ease-in-out',
            [FloatingButtonExtendedThemeStates.PRESSED]: {
                background_color: FOUNDATIONS.color_comp_actions_floatingbuttonextended_pressed_bg,
                border_color: FOUNDATIONS.color_comp_actions_floatingbuttonextended_pressed_border,
            },
            [FloatingButtonExtendedThemeStates.LOADING]: {
                background_color: FOUNDATIONS.color_comp_actions_floatingbuttonextended_loading_bg,
                border_color: FOUNDATIONS.color_comp_actions_floatingbuttonextended_loading_border,
            },
            [FloatingButtonExtendedThemeStates.DISABLED]: {
                background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                border_color: FOUNDATIONS.color_accent_disabled_border_100,
            },
        },
        buttonText: {
            font_variant: TextVariantType.FONT_PARAGRAPH_250,
            color: FOUNDATIONS.color_comp_actions_floatingbuttonextended_default_font,
            font_weight: FONT_WEIGHT.font_bold,
            [FloatingButtonExtendedThemeStates.DISABLED]: {
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                color: FOUNDATIONS.color_accent_disabled_font_100,
                font_weight: FONT_WEIGHT.font_bold,
            },
        },
        buttonIcon: {
            color: FOUNDATIONS.color_comp_actions_floatingbuttonextended_default_icon,
            height: FOUNDATIONS.size_350,
            width: FOUNDATIONS.size_350,
            [FloatingButtonExtendedThemeStates.DISABLED]: {
                color: FOUNDATIONS.color_accent_disabled_icon_100,
                height: FOUNDATIONS.size_350,
                width: FOUNDATIONS.size_350,
            },
        },
    },
});
//# sourceMappingURL=primaryStyles.js.map